var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.56274 10.0003C1.19824 10.0003 0.888244 9.87251 0.632744 9.61701C0.377744 9.36201 0.250244 9.05226 0.250244 8.68776V1.31226C0.250244 0.947756 0.377744 0.638006 0.632744 0.383006C0.888244 0.127506 1.19824 -0.000244141 1.56274 -0.000244141H11.4372C11.8017 -0.000244141 12.1117 0.127506 12.3672 0.383006C12.6222 0.638006 12.7497 0.947756 12.7497 1.31226V8.68776C12.7497 9.05226 12.6222 9.36201 12.3672 9.61701C12.1117 9.87251 11.8017 10.0003 11.4372 10.0003H1.56274ZM11.4372 2.62476L6.84349 5.48451C6.79149 5.51551 6.73699 5.54151 6.67999 5.56251C6.62249 5.58351 6.56249 5.59401 6.49999 5.59401C6.43749 5.59401 6.37749 5.58351 6.31999 5.56251C6.26299 5.54151 6.20849 5.51551 6.15649 5.48451L1.56274 2.62476V8.68776H11.4372V2.62476ZM6.49999 4.40601L11.4687 1.31226H1.54699L6.49999 4.40601ZM1.56274 2.78151V1.82826V1.84401V1.83576V2.78151Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.31c1a29949e86d2d8b95d3d91397a5a9.svg";
export { ForwardRef as ReactComponent };